import React from "react";
import { FileText } from "@phosphor-icons/react";

interface PdfViewerProps {
  pdfUrl: string | null;
  pdfName: string | null;
  onClose: () => void;
}

const PdfViewer: React.FC<PdfViewerProps> = ({ pdfUrl, pdfName, onClose }) => {
  return (
    <div className="lg:col-span-1">
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 sticky top-20">
        <div className="p-4 border-b border-gray-200">
          <div className="flex items-center justify-between">
            <h3 className="text-lg font-semibold">PDF Voorvertoning</h3>
            <button
              onClick={onClose}
              className="text-gray-500 hover:text-gray-700"
            >
              ×
            </button>
          </div>
          {pdfName && (
            <p className="text-sm text-gray-600 truncate">{pdfName}</p>
          )}
        </div>
        <div className="aspect-3/4 bg-gray-50">
          {pdfUrl ? (
            <iframe
              src={pdfUrl}
              className="w-full h-full border-0"
              title={`PDF Preview: ${pdfName}`}
            />
          ) : (
            <div className="flex items-center justify-center h-full text-gray-500">
              <div className="text-center">
                <FileText size={48} className="mx-auto mb-2 text-gray-400" />
                <p>Klik op een PDF rij voor voorvertoning</p>
              </div>
            </div>
          )}
        </div>
        {pdfUrl && (
          <div className="p-4 border-t border-gray-200">
            <div className="flex gap-2">
              <button
                onClick={() => window.open(pdfUrl, '_blank')}
                className="flex-1 px-3 py-2 bg-blue-50 text-blue-600 border border-blue-200 rounded-sm text-sm hover:bg-blue-100 transition-colors"
              >
                Open in Nieuw Tabblad
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default PdfViewer;